(ns app.front.ui.save-search-dialog
  (:require [app.front.ui :as ui]
            [app.front.ui.v2.dialog :as dialog]
            [app.front.util :as futil]
            [clojure.string :as str]
            [core.front.carbon :as cc]))


(defn- preview-box
  "Bordered box showing what the saved search will restore."
  [preview-text]
  (when-not (str/blank? preview-text)
    [:div.border.border-solid.border-ui-gray.rounded.p-4
     {:data-cy "save-search-dialog-preview"}
     preview-text]))


(defn save-search-dialog
  "Lightweight v2 dialog for saving the current search state under a user-given name.

  Re-frame-free: all state and side effects come in as props and callbacks.

  The name input is auto-focused when the dialog opens; backdrop click and ESC
  close the dialog (handled by the v2 dialog).

  Props:
    :open?            - whether the dialog is open
    :name             - current value of the name input
    :on-name-change   - called with the new name string on every keystroke
    :on-save          - called when the Save button is clicked
    :on-close         - called on Cancel, header X, backdrop click and ESC close
    :title            - dialog title
    :description      - text shown under the title
    :name-label       - label of the name input
    :name-placeholder - placeholder of the name input
    :preview-text     - breadcrumb of what will be saved (box hidden when blank)
    :save-label       - label of the primary (Save) button
    :cancel-label     - label of the Cancel button
    :close-label      - aria-label of the header close (X) button
    :saving?          - shows a spinner and keeps Save disabled while truthy
    :data-cy          - optional root data-cy hook"
  [{:keys [open? name on-name-change on-save on-close
           title description name-label name-placeholder
           preview-text save-label cancel-label close-label saving? data-cy]}]
  [dialog/dialog
   {:open?       open?
    :on-close    on-close
    :close-label close-label
    :class       "max-w-lg"
    :aria-label  title
    :data-cy     data-cy
    :header      [:div
                  [:h2.text-lg.font-semibold title]
                  [:p.pt-2.pb-2.text-sm description]]
    :body        [:<>
                  (when-not (str/blank? description)
                    [:hr {:class "border-t border-ui-light-gray"}])
                  [:div.px-6.py-4
                   [ui/text-input {:id          "save-search-dialog-name"
                                   :data-cy     "save-search-dialog-name"
                                   :label-text  name-label
                                   :placeholder name-placeholder
                                   :auto-focus  true
                                   :required    true
                                   :disabled    saving?
                                   :value       (or name "")
                                   :on-change   #(on-name-change (futil/tval %))}]
                   [:div.mt-4
                    [preview-box preview-text]]]]
    :footer      [:div.flex.items-center.justify-between
                  [ui/button {:kind     :secondary
                              :size     :small
                              :data-cy  "save-search-dialog-cancel"
                              :on-click on-close}
                   cancel-label]
                  [:div.flex.items-center.gap-2
                   (when saving?
                     (cc/inline-loading {:class-name "my-2"}))
                   [ui/button {:kind       :primary
                               :size       :small
                               :class-name "uppercase"
                               :data-cy    "save-search-dialog-save"
                               :disabled   (or saving? (str/blank? name))
                               :on-click   on-save}
                    save-label]]]}])
